import Breadcrumb from "@/components/feature/Breadcrumb";
import ContactForm from "./components/ContactForm";
import { usePageMeta } from "@/hooks/usePageMeta";

const wrap = "mx-auto w-full max-w-[1280px] px-4 md:px-6";

const scopeItems = [
  { icon: "ri-film-line", title: "剧集聚合", desc: "收录多部泰国双男主题材剧集，配以剧照、主演、剧情简介与分类标签。" },
  { icon: "ri-price-tag-3-line", title: "多维分类", desc: "支持按分类、标签、年份与评分筛选，并提供多条件排序，快速定位想看的内容。" },
  { icon: "ri-newspaper-line", title: "影视资讯", desc: "汇总最新剧集动态、行业观察与幕后报道，了解作品背后的故事。" },
  { icon: "ri-search-line", title: "快捷搜索", desc: "输入剧名、演员或题材关键词即可模糊检索，一步找到相关作品。" },
];

export default function AboutPage() {
  usePageMeta(
    "关于我们 - 泰剧腐剧双男主",
    "了解泰剧腐剧双男主的站点定位、内容范围与联系方式，我们专注泰国双男主题材影视的内容聚合与推荐。",
  );

  return (
    <div className={wrap}>
      <div className="border-b border-background-200 pt-6 pb-6">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
        <h1 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">关于我们</h1>
        <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-600">
          泰剧腐剧双男主是一个专注泰国双男主题材影视的内容聚合平台，我们希望让每一位爱好者都能更轻松地了解作品、找到想看的剧。
        </p>
      </div>

      <section className="mt-10">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.4fr_1fr] lg:gap-8">
          <div className="rounded-lg border border-background-200 bg-gradient-to-br from-primary-50 via-background-50 to-accent-50 p-6 md:p-8">
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-heart-3-fill text-2xl"></i>
            </span>
            <h2 className="mt-5 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">品牌介绍</h2>
            <p className="mt-3 text-sm leading-loose text-foreground-700 md:text-base">
              我们因为对泰国双男主题材的喜爱而聚在一起。从校园青涩的暗恋，到黑帮世界的生死相依，
              这类作品总能以细腻的情感打动人心。然而面对数量庞大、信息分散的剧集，很多人常常不知道该从哪里看起。
            </p>
            <p className="mt-3 text-sm leading-loose text-foreground-700 md:text-base">
              「泰剧腐剧双男主」希望成为你的观剧向导：用清晰的分类与严谨的剧集资料整理，
              帮助你在最短时间内了解一部作品的题材、主演与剧情脉络，从而更快地做出选择。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="font-heading text-3xl font-black text-primary-600">12+</p>
              <p className="mt-1 text-sm text-foreground-500">精选剧集</p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="font-heading text-3xl font-black text-primary-600">12</p>
              <p className="mt-1 text-sm text-foreground-500">题材标签</p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="font-heading text-3xl font-black text-primary-600">4</p>
              <p className="mt-1 text-sm text-foreground-500">内容分类</p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="font-heading text-3xl font-black text-primary-600">100%</p>
              <p className="mt-1 text-sm text-foreground-500">内容整理</p>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-12">
        <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">站点内容范围</h2>
        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {scopeItems.map((item) => (
            <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-500">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-12">
        <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
          <h2 className="flex items-center gap-2 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
              <i className="ri-information-line text-lg"></i>
            </span>
            内容说明
          </h2>
          <ul className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-600">
            <li className="flex gap-2">
              <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
              本站为影视资讯与内容推荐平台，不提供任何影片的在线播放与下载服务。
            </li>
            <li className="flex gap-2">
              <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
              页面展示的剧集信息、剧照与简介均用于内容介绍与观众参考。
            </li>
            <li className="flex gap-2">
              <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
              收藏功能基于你的浏览器本地存储，数据仅保存在你自己的设备上。
            </li>
            <li className="flex gap-2">
              <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
              如相关内容涉及版权问题，欢迎通过下方表单与我们联系，我们会及时处理。
            </li>
          </ul>
        </div>
      </section>

      <section className="mt-12">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_1.2fr] lg:gap-8">
          <div>
            <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">联系与合作</h2>
            <p className="mt-3 text-sm leading-loose text-foreground-600">
              无论你是想推荐一部心仪的剧集、指出内容中的疏漏，还是希望与我们展开内容合作，
              都可以通过右侧的表单联系我们。我们会认真阅读每一条留言，并尽快给予回复。
            </p>
            <div className="mt-5 space-y-3">
              <p className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-mail-line text-primary-500"></i>contact@thaibldrama.com
              </p>
              <p className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-time-line text-primary-500"></i>工作时间：周一至周五 10:00 - 18:00
              </p>
              <p className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-map-pin-line text-primary-500"></i>内容团队 · 线上协作
              </p>
            </div>
          </div>
          <ContactForm />
        </div>
      </section>

      <section className="mt-12 pb-4">
        <div className="rounded-lg border border-background-200 bg-background-50 p-6 text-center md:p-8">
          <h2 className="font-heading text-lg font-bold text-foreground-950">版权声明</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-loose text-foreground-500">
            本站所有剧集相关信息、剧照与简介均来源于公开资料，仅用于内容介绍与学习交流，版权归原作者及出品方所有。
            本站不提供任何影片的在线播放与下载服务。若相关内容侵犯了您的权益，请联系我们进行处理。
          </p>
          <p className="mt-4 text-xs text-foreground-400">
            © {new Date().getFullYear()} 泰剧腐剧双男主 · 保留所有权利
          </p>
        </div>
      </section>
    </div>
  );
}